module.exports = __webpack_public_path__ + "static/img/wx.f21fb1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx.png
// module id = kfBz
// module chunks = 10